export enum CivilStatus {
    Single = 'Single',
    Married = 'Married',
    Divorced = 'Divorced',
    Separated = 'Separated',
    Widowed = 'Widowed',
    InRegisteredPartnership = 'InRegisteredPartnership'
}
